import { render, staticRenderFns } from "./AppTermsModal.vue?vue&type=template&id=7d332072&"
import script from "./AppTermsModal.vue?vue&type=script&lang=js&"
export * from "./AppTermsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports